import React, { useContext } from "react";
import { Context } from "../../../../index";
import { observer } from "mobx-react-lite";
import "./styles.css";
import PopupStation from "../../../../components/forms/popupStation";
import StationCard from "./StationCard";
import SVG from "../../../../components/svg/Svg";
import Modal from "../../../../components/forms/wrap/Modal";

export default observer(function Station() {
  const { store, uiStore, inplantsStore } = useContext(Context);

  const closePopup = () => {
    inplantsStore.setActiveStation(null);
  };

  // --- Выбор станции ---
  const selectStation = (station) => {
    if (inplantsStore.activeStation?.id === station.id) {
      inplantsStore.setActiveStation(null);
    } else {
      inplantsStore.setActiveStation(station);
    }
  };

  const filteredStations = (() => {
    let stations = inplantsStore.stations.filter((station) => station["Meters.meter_address"] !== 0);

    // Фильтрация по линии: если линия выделена, показывать станции только модулей этой линии
    if (uiStore.selectedLineId !== null) {
      // Получаем модули выделенной линии
      const lineModules = inplantsStore.modules.filter((module) => module.line_id === uiStore.selectedLineId);
      const lineModuleIds = lineModules.map((module) => module.id);

      stations = stations.filter((station) => lineModuleIds.includes(station.module_id));
    }

    // Фильтрация по модулю (существующая логика)
    if (uiStore.selectedModuleId !== null) {
      stations = stations.filter((station) => station.module_id === uiStore.selectedModuleId);
    }

    return stations;
  })();

  return (
    <div className="station_container">
      <div className="lines_head">
        <div className="lines_head_title">СТАНЦИИ ОБЪЕКТА {SVG["line"]}</div>
      </div>

      <div className="stations">
        {filteredStations.map((station) => (
          <StationCard
            key={station.id}
            station={station}
            onSelect={() => selectStation(station)}
            role={store.user?.role}
          />
        ))}
      </div>

      {/* Модалка: детали станции */}
      <Modal isOpen={!!inplantsStore.activeStation?.id} onClose={closePopup}>
        <PopupStation
          station={inplantsStore.activeStation}
          modules={inplantsStore.modules}
          handleCloseModal={closePopup}
          position="inplants"
          updateStation={(station, position) => inplantsStore.updateStation(station, position)}
          restartStation={(id, controller) => inplantsStore.restartStation(id, controller)}
          AvailabilityStation={(id, moduleId, controller, availability) => inplantsStore.AvailabilityStation(id, moduleId, controller, availability)}
          UnlockConnector={(id, controller) => inplantsStore.UnlockConnector(id, controller)}
          refreshData={() => {
            if (inplantsStore.plant?.id) {
              inplantsStore.loadPlantData(inplantsStore.plant.id);
            }
          }}
        />
      </Modal>
    </div>
  );
});
